<div class="container-fluid p-0">
  <mat-card appearance="outlined" *ngFor="let item of items; let i = index" class="p-3" [id]="item.id">

    <mat-card-title>
      <h6>{{ item.name }}</h6>
    </mat-card-title>

    <mat-card-subtitle class="px-0">
      <div class="alert alert-info" role="alert">
        <small>{{ item.tooltip }}</small>
      </div>

      <p *ngIf="edit"><strong>{{ item.question }}</strong></p>

      <p *ngIf="!edit">Do you have <strong>{{ item.name }}</strong> documents? <span>{{ item.pivot.answer }}</span></p>

      <mat-button-toggle-group [(ngModel)]="item.pivot.answer" (change)="onUpdateAnswer(item)" aria-label="Answer" *ngIf="edit">
        <mat-button-toggle value="Yes">Yes</mat-button-toggle>
        <mat-button-toggle value="No">No</mat-button-toggle>
        <mat-button-toggle value="NA">Not Applicable</mat-button-toggle>
      </mat-button-toggle-group>
    </mat-card-subtitle>

    <mat-card-content class="px-0">
      <app-files-list [files]="item.pivot.files" [view]="!edit" *ngIf="item.pivot.answer == 'Yes'" (changedFiles)="onFilesChanged(item, $event)"></app-files-list>
    </mat-card-content>

    <mat-card-actions class="flex-wrap px-0" *ngIf="edit; else showMeta">

      <app-files-selector
        class="my-2 ml-0 mr-3"
        (selected)="newFiles[item.pivot.id] = $event"
        *ngIf="item.pivot.answer == 'Yes'"
        [selectedFilesCount]="newFiles[item.pivot.id]?.length">
      </app-files-selector>

      <button
        mat-raised-button
        class="my-2 ml-0 mr-3"
        color="accent"
        (click)="onUpload(i)"
        [disabled]="!newFiles[item.pivot.id] || inProgresses[i]" *ngIf="item.pivot.answer == 'Yes'">
        <mat-icon id="save">cloud_upload</mat-icon>
        Upload
      </button>

      <button
        mat-raised-button
        class="my-2 ml-0 mr-3"
        color="secondary"
        (click)="onAddNotes(item)"
        [matBadge]="item.pivot.notes ? 1 : 0">
        <mat-icon>speaker_notes</mat-icon>
        Add Notes
      </button>

      <div class="ml-auto mr-2">
        <span *ngIf="item.pivot.answer == 'Yes'">
          <mat-form-field class="full-width my-2" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Expiry Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Expiry Date"
              readonly
              [(ngModel)]="expiries[item.pivot.id]"
              name="expiry {{ item.pivot.id }}"
              (click)="picker.open()"
              (dateChange)="onExpiryChanged(item)"
              matTooltip="Please select an expiry date if the uploaded documents have one." />
            <mat-datepicker-toggle matSuffix [for]="picker" matTooltip="Select expiry date."></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>

            <button
              *ngIf="expiries[item.pivot.id]"
              type="button"
              matSuffix
              mat-icon-button
              (click)="removeExpiry(item)"
              matTooltip="Remove the Pre-Qualification document expiry date.">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </span>
      </div>

      <div
        *ngIf="item.pivot.answer == 'Yes' && expiryChanged(item.pivot.id) && !(item.pivot.files?.length > 0)"
        class="w-100 d-flex"
      >
        <mat-form-field class="w-100 my-2" appearance="outline">
          <mat-label>Reason for Expiry Date Change</mat-label>
          <textarea
            matInput
            [(ngModel)]="expiryChangeNotes[item.pivot.id]"
            name="expiry_note_{{ item.pivot.id }}"
            rows="3"
            required
            (blur)="saveExpiry(item)"
          ></textarea>
          <mat-hint>This note will be included in the notification email.</mat-hint>
        </mat-form-field>
      </div>
    </mat-card-actions>

    <ng-template #showMeta>
      <mat-card-subtitle>
        <p><strong>Notes:</strong> {{ item.pivot.notes || 'None' }}</p>
        <p><strong>Expiry Date:</strong><span [ngClass]="getExpiryClass(item.pivot?.expiry)"> {{ expiries[item.pivot.id] ? expiries[item.pivot.id].format("DD/MM/YYYY") : 'None' }}</span></p>
      </mat-card-subtitle>
    </ng-template>
  </mat-card>
</div>
